import {
  useFeatureFlagOverrides,
  useMobileMappingFlags,
} from '@mobile-mapping/providers';
import { Component } from 'solid-js';

import type { FeatureFlagToggleProps } from './FeatureFlagToggle.types';
import { LabeledSwitch } from './LabeledSwitch';

export const FeatureFlagToggle: Component<FeatureFlagToggleProps> = (props) => {
  const { hasFlag } = useMobileMappingFlags();
  const { setOverride } = useFeatureFlagOverrides();

  return (
    <LabeledSwitch
      label={props.flag}
      value={hasFlag(props.flag)}
      onToggle={() => setOverride(props.flag, !hasFlag(props.flag))}
    />
  );
};
